module.exports = __webpack_public_path__ + "img/BecomePan-1.03840d9e.svg";